import axios from 'axios';
import { store } from '../store'; // Import your Redux store
import { toast } from 'react-toastify';
import { logout } from '../reducer/authSlice';
import { persistor } from '../store';
import { storeRedirectUrl } from '../utils/sessionUtils';

// Create an Axios instance
const rootAxios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// Add a request interceptor to include the token dynamically
rootAxios.interceptors.request.use(
  (config) => {
    // Access the token from the Redux store
    const state = store.getState();
    const { token, userData } = state.authSlice; // Adjust to match your Redux state structure

    // Attach the token to the Authorization header
    if (token) {
      config.headers.Authorization = `${token}`;
      config.headers.userid = userData.employeeId;
    }
    return config;
  },
  (error) => {
    // Handle the request error
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration
rootAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response?.status === 401 &&
      (error.response?.data?.message === 'Token was not recognised' ||
        error.response?.data?.message === 'Token has expired' ||
        error.response?.data?.message === 'Token not matched with userId')
    ) {
      // Show toast message
      toast.error('Session expired. Please login again.');

      // Store the current URL before clearing data
      storeRedirectUrl();

      // Clear persisted data
      await persistor.purge();

      // Dispatch logout action
      store.dispatch(logout());

      // Redirect to login page
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default rootAxios;
